<div class="fixed inset-0 z-50 flex items-center justify-center" role="dialog" aria-modal="true">
  <div class="absolute inset-0 bg-black/40" (click)="close()"></div>
  <div class="relative bg-white rounded-xl shadow-xl w-full max-w-md p-6 mx-4">
    <h3 class="font-semibold text-gray-900 mb-3">Export leads</h3>

    <!-- Loading summary -->
    <div *ngIf="isLoadingSummary" class="space-y-2 animate-pulse py-2">
      <div class="h-4 bg-gray-200 rounded w-2/3"></div>
      <div class="h-3 bg-gray-100 rounded w-full"></div>
      <div class="h-3 bg-gray-100 rounded w-1/2"></div>
    </div>

    <div *ngIf="!isLoadingSummary && summaryError" class="text-sm text-gray-600 mb-4">
      Couldn't load the email summary.
      <button type="button" class="text-violet-600 font-medium hover:underline" (click)="loadSummary()">Retry</button>
      — you can still export without unlocking.
    </div>

    <ng-container *ngIf="!isLoadingSummary && summary">
      <p class="text-sm text-gray-800 font-medium mb-2">
        {{ summary.total | number }} leads · {{ summary.unlocked | number }} unlocked · {{ summary.locked | number }} locked
      </p>
      <div *ngIf="offerUnlock" class="rounded-lg bg-gray-50 border border-gray-100 p-3 text-sm text-gray-700 mb-2">
        Unlock {{ summary.locked | number }} emails: up to <span class="font-semibold">{{ summary.max_cost | number }} credits</span>
        ({{ summary.cost_per_email || 2 }} per email found, nothing if not found) · balance {{ summary.balance | number }}
        <span *ngIf="shortOfCredits" class="block text-amber-700 mt-1">
          Your balance covers about {{ summary.affordable | number }} emails — unlocking stops when credits run out.
        </span>
      </div>
      <p *ngIf="summary.locked === 0" class="text-sm text-gray-500 mb-2">Every email that can be unlocked already is.</p>
    </ng-container>

    <app-export-columns-picker *ngIf="!isLoadingSummary" [value]="columns" (valueChange)="columns = $event" [disabled]="busy"></app-export-columns-picker>

    <!-- Unlock job progress -->
    <div *ngIf="phase === 'unlocking' && job" class="mt-3">
      <div class="flex justify-between text-xs text-gray-500 mb-1">
        <span>Unlocking emails… {{ job.processed }}/{{ job.total }}</span>
        <span>{{ job.found }} found · {{ job.credits_used }} credits</span>
      </div>
      <div class="h-2 rounded-full bg-gray-100 overflow-hidden">
        <div class="h-full bg-violet-500 transition-all duration-500" [style.width.%]="jobProgress"></div>
      </div>
    </div>

    <div class="flex flex-col sm:flex-row justify-end gap-2 mt-5">
      <button type="button"
              class="px-4 py-2 rounded-lg border border-gray-300 text-sm text-gray-600 hover:bg-gray-50 disabled:opacity-50"
              [disabled]="busy" (click)="close()">
        Cancel
      </button>
      <button type="button"
              class="px-4 py-2 rounded-lg border border-violet-600 text-violet-700 text-sm font-medium hover:bg-violet-50 disabled:opacity-50 inline-flex items-center justify-center gap-2"
              [disabled]="busy || isLoadingSummary" (click)="exportWithoutUnlocking()">
        <span *ngIf="phase === 'downloading'" class="w-4 h-4 border-2 border-violet-300 border-t-violet-600 rounded-full animate-spin"></span>
        {{ phase === 'downloading' ? 'Preparing file…' : (offerUnlock ? 'Export without unlocking' : 'Export') }}
      </button>
      <button *ngIf="offerUnlock || phase === 'starting' || phase === 'unlocking'" type="button"
              class="px-4 py-2 rounded-lg bg-violet-600 text-white text-sm font-medium hover:bg-violet-700 disabled:opacity-50 inline-flex items-center justify-center gap-2"
              [disabled]="busy || isLoadingSummary || summaryError || !summary?.locked" (click)="unlockAndExport()">
        <span *ngIf="phase === 'starting' || phase === 'unlocking'" class="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin"></span>
        {{ phase === 'starting' || phase === 'unlocking' ? 'Unlocking…' : 'Unlock all & export' }}
      </button>
    </div>
  </div>
</div>
